<template>
  <FormContainer :title="$t('title.adminDiscount')" :onSubmit="onSubmit">
    <div class="columns" style="height:430px;">
      <div class="column">
        <FormItem>
          <b-input
            v-model="data.code"
            v-validate="'required'"
            name="code"
            v-cleave="{ uppercase: true, blocks: [50] }"
            expanded
          />
        </FormItem>
        <FormItem>
          <b-input
            v-model="data.value"
            icon-pack="fas"
            icon="percent"
            v-validate="'required'"
            name="discount"
            expanded
          />
        </FormItem>
      </div>
      <div class="column">
        <FormItem>
          <b-datetimepicker
            v-model="data.expireDate"
            name="expireDate"
            icon-pack="fas"
            icon="calendar"
            :min-date="new Date()"
            :datepicker="dateSettings"
          ></b-datetimepicker>
        </FormItem>
      </div>
    </div>
  </FormContainer>
</template>

<script>
import dateSettings from '@/_helpers/date.config'
import ApiService from '../../../_api/api.service'

export default {
  props: ['id'],
  data() {
    return {
      data: {},
      dateSettings: {}
    }
  },
  mounted() {
    const { firstDayOfWeek, monthNames, dayNames } = dateSettings
    this.dateSettings = { firstDayOfWeek, monthNames, dayNames }
    if (this.id) {
      this.getData()
    }
  },
  methods: {
    getData() {
      ApiService.get(`/discount/${this.id}`).then(data => {
        // eslint-disable-next-line no-param-reassign
        data.expireDate = new Date(Date.parse(data.expireDate))
        this.data = data
      })
    },
    onSubmit() {
      ApiService.post('/discount', { discount: this.data }).then(data => {
        this.data = data
        this.$emit('saved')
        this.$parent.close()
      })
    }
  }
}
</script>
